var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "portal_cebas.credentialing.config.create",
              expression: "'portal_cebas.credentialing.config.create'"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { "400": true }
            }
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew }
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" }
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew")))
          ])
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "/portal-cebas/credentialings/configs",
          order_column: "created_at",
          direction: "desc"
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function() {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID")
                ]),
                _c(
                  "vs-th",
                  {
                    key: "legal_entity_name",
                    attrs: { "sort-key": "legal_entity_id" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("portal_cebas.credentialing.legal_entity"))
                    )
                  ]
                ),
                _c("vs-th", { key: "title", attrs: { "sort-key": "title" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("portal_cebas.credentialing.title_page"))
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "gridData",
            fn: function(props) {
              return _vm._l(props.data, function(tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.id) + " ")])
                    ]),
                    _c(
                      "vs-td",
                      { key: "legal_entity_name", attrs: { width: "40%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.legal_entity_name))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "title_page", attrs: { width: "50%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.title_page))])]
                    ),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "portal_cebas.credentialing.config.edit",
                                expression:
                                  "'portal_cebas.credentialing.config.edit'"
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: "Editar Configuração",
                                  delay: { show: 100, hide: 100 }
                                },
                                expression:
                                  "{content: 'Editar Configuração',delay: { show: 100, hide: 100 }}",
                                modifiers: { top: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: { icon: "EditIcon" },
                            on: {
                              click: function($event) {
                                return props.edit(props.data[indextr].id)
                              }
                            }
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value:
                                  "portal_cebas.credentialing.config.delete",
                                expression:
                                  "'portal_cebas.credentialing.config.delete'"
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: "Excluir Configuração",
                                  delay: { show: 100, hide: 100 }
                                },
                                expression:
                                  "{content: 'Excluir Configuração',delay: { show: 100, hide: 100 }}",
                                modifiers: { top: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                            attrs: { icon: "Trash2Icon" },
                            on: {
                              click: function($event) {
                                return props.destroy(props.data[indextr])
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }